(function() { window.GUID_25772201_28d8_4e67_8113_74be9f3d0750 = { getGuid: function() { return "25772201-28d8-4e67-8113-74be9f3d0750"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SortDirection;
        (function (SortDirection) {
            SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
            SortDirection[SortDirection["Descending"] = 1] = "Descending";
        })(SortDirection = Enumeration.SortDirection || (Enumeration.SortDirection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SortDirection.pre.js.map
